<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      新安公园站<br>
站点介绍<br>
新安公园站位于前进一路和新安二路的交叉口处,沿前进一路南北向敷设。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	06:29	23:25	12号线	4分钟	8分钟<br>
海上田园东	06:22	23:46	12号线	4分钟	8分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	06:33	23:25	12号线	8分钟	8分钟<br>
海上田园东	06:24	23:46	12号线	8分钟	8分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	－	－	12号线	－	－<br>
海上田园东	－	－	12号线	－	－<br><br>

站点出口信息<br><br>
A出入口:<br>
前进一路北侧（东），新安二路西，新安公园、宝安区老干部活动中心、宝安人民医院<br><br>
B出入口:<br>
前进一路北侧（西）,新安公园停车场、宝民小学 C1出入口<br><br>
C2出入口:<br>
前进一路南侧、宝安区公共就业服务大楼 D出入口<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 宝安人民医院站<br>
605、615、718、M246、B904、M206、M245、M469、M550、606、高峰专线172<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shierhaoxian",
            title: "12号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>